import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import UpsellCard from '../subscription/UpsellCard';
import UpsellCardOnAir from '../subscription/UpsellCardOnAir';
import { selectBreakpoint } from '../../selectors/app';
import { SMALL } from '../../styles/breakpoints';
import { SOURCE_ONAIR } from '../../constants/sourceQueryParams';
import generateOriginLabelFromQuery from '../../utils/generateOriginLabelFromQuery';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './payment-flow-form-layout.module.scss';

export class PaymentFlowFormLayout extends Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
    alwaysShowUpsellTable: PropTypes.bool.isRequired,
    isPaymentFlow: PropTypes.bool,
    isNoPaymentFlow: PropTypes.bool,
    selectedProduct: PropTypes.object,
    formContainerClassName: PropTypes.string,
    resetFormPadding: PropTypes.bool,
    breakpoint: PropTypes.number.isRequired, // mapStateToProps
  };

  static contextType = LocationAndLocalizationContext;

  static defaultProps = {
    formContainerClassName: '',
  };

  render() {
    const {
      children,
      isPaymentFlow,
      alwaysShowUpsellTable,
      isNoPaymentFlow,
      selectedProduct,
      formContainerClassName,
      resetFormPadding,
      breakpoint, // mapStateToProps
    } = this.props;

    const { location } = this.context;
    const source = generateOriginLabelFromQuery(location);
    const isOnAirFlow = source === SOURCE_ONAIR;

    const shouldShowUpsellCard =
      isPaymentFlow && (alwaysShowUpsellTable || breakpoint >= SMALL);
    const noPaddingClassName = { [css.noPadding]: resetFormPadding };

    return (
      <div
        data-testid="paymentFlowFormLayoutContainer"
        className={classnames(css.formLayoutContainer, noPaddingClassName)}
      >
        <div
          data-testid="paymentFlowFormInnerLayoutContainer"
          className={css.formLayoutInnerContainer}
        >
          <div
            data-testid="paymentFlowFormContainer"
            className={
              isPaymentFlow
                ? css.innerFormLayoutContainerColumn
                : css.innerFormLayoutContainerRow
            }
          >
            {!isOnAirFlow && shouldShowUpsellCard && (
              <UpsellCard
                isNoPaymentFlow={isNoPaymentFlow}
                selectedProduct={selectedProduct}
              />
            )}
            {isOnAirFlow && <UpsellCardOnAir />}
            <div
              data-testid="paymentFlowForm"
              className={classnames(
                css.formContainer,
                noPaddingClassName,
                formContainerClassName,
              )}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    breakpoint: selectBreakpoint(state),
  };
}

export default connect(mapStateToProps)(PaymentFlowFormLayout);
